import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'price'})
export class PricePipe implements PipeTransform {

  public transform(value: number, args?: string[]): string {
    let postFix = args && args[0] === 'hourly' ? '€/h' : '€';
    if (!value) {
      return `0 ${postFix}`;
    }

    let rounded = Number(Math.round(value * 100) / 100).toFixed(2);
    return `${rounded} ${postFix}`;
  }

}
